export const SMALL = "230px";
export const BIG = "460px";
